import React from "react";
import { AppListing } from "../../../../components/appListing";
import { supportContactCols, supportProviderCols, supportSupplierCols } from "../../constant";

const CareplanSupport = ({ supportData = {}, loading = false }) => {
  return (
    <div className="py-2">
      <div>
        <p className="text-red-400 text-xl font-bold py-5">Contact</p>
        <AppListing
          loading={loading}
          listData={supportData?.contact || []}
          cols={supportContactCols}
        />
      </div>
      <div>
        <p className="text-red-400 text-xl font-bold py-5">Provider</p>
        <AppListing
          loading={loading}
          listData={supportData?.other_providers || []}
          cols={supportProviderCols}
        />
      </div>
      <div>
        <p className="text-red-400 text-xl font-bold py-5">Supplier</p>
        <AppListing
          loading={loading}
          listData={supportData?.suppliers || []}
          cols={supportSupplierCols}
        />
      </div>
    </div>
  );
};

export default CareplanSupport;
